/**
 * Cloud notes persist two representations: Markdown (`workspace_files`) and
 * Yjs (`workspace_file_ydoc_*`). The editor mounts from Yjs whenever the
 * fragment is non-empty, so a successful Markdown save can still leave another
 * origin on stale Yjs.
 *
 * Prefer Markdown only when it is clearly newer than the Yjs cloud clock and
 * the local Yjs doc is not holding unsaved edits.
 */
export function shouldPreferMarkdownOverYjs(input: {
  markdown: string;
  yjsMarkdown: string;
  markdownMtimeMs: number | null;
  yjsUpdatedAtMs: number | null;
  yjsDirty: boolean;
}): boolean {
  if (
    normalizeMarkdown(input.markdown) === normalizeMarkdown(input.yjsMarkdown)
  ) {
    return false;
  }
  // Local unsaved Yjs edits must not be clobbered by an older Markdown row.
  if (input.yjsDirty) {
    return false;
  }
  // No durable Yjs clock — Markdown is the cross-origin recovery source.
  if (input.yjsUpdatedAtMs == null) {
    return true;
  }
  if (input.markdownMtimeMs == null) {
    return false;
  }
  return input.markdownMtimeMs > input.yjsUpdatedAtMs;
}

function normalizeMarkdown(markdown: string): string {
  return markdown.replace(/\r\n?/g, '\n').replace(/\s+$/u, '');
}
